import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Customer } from '@df/session/api/customer';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';

@Component({
    selector: 'account-view-content',
    templateUrl: './account-view-content.component.html',
    standalone: true,
    imports: [CommonModule, RouterModule, SizeClassDirective, TranslatePipe]
})
export class AccountViewContentComponent {
    @Input()
    title?: string;

    @Input()
    url?: string;

    @Input()
    onBackClick?: () => void;

    constructor(readonly customer: Customer) {}
}
